import React, { useState } from "react";
import { Input } from "@douyinfe/semi-ui";

import type { ValidateStatus } from "@douyinfe/semi-ui/lib/es/input";
import { replaceWhitespace } from "@utils/common.util";
import { parseRanges } from "@utils/validator";
import { BinderSequenceModel } from "@services/home/model/home.model";
import styles from "./index.module.scss";

interface Prop {
  sequence: BinderSequenceModel;
  cancel: () => void;
  submit: (hotspot: string) => void;
}

const HotspotEditor: React.FC<Prop> = ({ sequence, cancel, submit }) => {
  const [hotspotValue, setHotspotValue] = useState(sequence.hotspots || "");
  const [validateStatus, setValidateStatus] = useState<ValidateStatus>();
  const [errorMsg, setErrorMsg] = useState("");

  function validateHotspot(val: string, entity_sequence?: string) {
    const regex = /^(\d+(-\d+)?)(,(\d+(-\d+)?))*$/;

    const v = replaceWhitespace(val);
    if (!v) return "";

    if (!regex.test(v)) {
      return "Invalid format";
    }

    if (!entity_sequence) {
      return "Insert sequence above first";
    }

    const len = entity_sequence.length;

    const matrix = parseRanges(v);

    const invalid = matrix.some(([start, end]) => {
      if (start > end) {
        return true;
      } else if (start < 1 || start > len) {
        return true;
      } else if (end < 1 || end > len) {
        return true;
      } else {
        return false;
      }
    });

    if (invalid) {
      return "Out of range";
    }
  }

  function onCancel() {
    cancel();
  }

  function onSubmtit() {
    if (!errorMsg) {
      submit(hotspotValue);
    }
  }

  function onValidate() {
    const msg = validateHotspot(hotspotValue, sequence.entity_sequence);
    if (msg) {
      setValidateStatus("error");
      setErrorMsg(msg);
    } else {
      setValidateStatus("default");
      setErrorMsg("");
    }
  }

  function onValueChange(v: string) {
    setHotspotValue(v);
    setValidateStatus("default");
    setErrorMsg("");
  }
  return (
    <div className={styles.container}>
      <div className={styles.label}>Hotspots residues: </div>
      <div className={styles.input}>
        <Input
          size="small"
          placeholder="Please enter"
          validateStatus={validateStatus}
          value={hotspotValue}
          onChange={onValueChange}
          onBlur={onValidate}
        />
        {errorMsg && <div className={styles.error}>{errorMsg}</div>}
      </div>
      <div className={styles.opt}>
        <span className={styles.cancelBtn} onClick={onCancel}>
          Cancel
        </span>
        <span className={styles.okBtn} onClick={onSubmtit}>
          Ok
        </span>
      </div>
    </div>
  );
};

export default HotspotEditor;
